import { tokenRef } from 'common/constant';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { useLocalStorage } from 'hooks/useStorage';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUserDetailsQuery } from 'redux/reducers/administrator';
import { backendURL } from 'redux/reducers/settings';

const UserHeader = () => {
  const { removeToken } = useLocalStorage(tokenRef);
  const navigate = useNavigate();
  const { data: userDetails } = useCurrentUserDetailsQuery();

  const handleLogout = () => {
    removeToken();
    window.location.href = '/user';
  };
  const { appConfig } = useContext(ConfigurationContext)

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm py-2">
      <div className="container-fluid px-lg-4">
        
        {/* Brand/Logo */}
        <div 
          className="navbar-brand d-flex align-items-center gap-2 m-0 cursor-pointer" 
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        >
          <img src={backendURL+appConfig?.logo} width={40} height={40} className="d-inline-block align-top" alt="Logo" />
          <div className="lh-sm">
            <span className="fw-bold d-none d-md-block" style={{ fontSize: '0.95rem', maxWidth: '250px', whiteSpace: 'normal' }}>
             {appConfig?.title}
            </span>
          </div>
        </div>

        {/* Mobile Toggle Button */}
        <button 
          className="navbar-toggler border-0 shadow-none" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarContent"
          aria-controls="navbarContent" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3">
                <li className="nav-item">
              <span 
                className="nav-link fw-semibold text-dark cursor-pointer" 
                onClick={() => navigate('/')}
                style={{ cursor: 'pointer' }}
              >
                Home
              </span>
            </li>
            <li className="nav-item">
              <span 
                className="nav-link fw-semibold text-dark cursor-pointer" 
                onClick={() => navigate('/completedTraining')}
                style={{ cursor: 'pointer' }}
              >
                Completed Training
              </span>
            </li>
            <li className="nav-item">
              <span 
                className="nav-link fw-semibold text-dark cursor-pointer" 
                onClick={() => navigate('/course')}
                style={{ cursor: 'pointer' }}
              >
                Learning Portal
              </span>
            </li>
          </ul>

          {/* User Profile Section */}
          <div className="d-flex align-items-center border-start ps-lg-4 ms-lg-2">
            <div className="dropdown">
              <div 
                className="d-flex align-items-center gap-2 cursor-pointer dropdown-toggle hide-caret" 
                id="userDropdown" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                style={{ cursor: 'pointer' }}
              >
                <div className="text-end d-none d-sm-block mr-2">
                  <div className="fw-bold small text-dark leading-none">
                    {userDetails?.first_name || 'User'}
                  </div>
                  <div className="text-muted tiny" style={{ fontSize: '11px' }}>Trainee</div>
                </div>
                <div className="position-relative">
                    <img
                      className="rounded-circle border border-2 border-primary border-opacity-25 p-1"
                      width={42}
                      height={42}
                      src={userDetails?.image ? (backendURL + userDetails?.image) : 'https://via.placeholder.com/40'}
                      alt="User"
                      style={{ objectFit: 'cover' }}
                    />
                </div>
              </div>

              <ul className="dropdown-menu  shadow border-0 mt-2 py-2" aria-labelledby="userDropdown">
                <li className="px-3 py-2 d-md-none">
                    <h6 className="mb-0 fw-bold">{userDetails?.first_name}</h6>
                    <p className="text-muted small mb-0">Trainee</p>
                </li>
                <li className="d-md-none"><hr className="dropdown-divider" /></li>
                
                <li>
                  <button className="dropdown-item py-2" onClick={() => navigate('/profile')}>
                    <i className="bi bi-person me-2"></i> My Profile
                  </button>
                </li>
             
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item py-2 text-danger fw-bold" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-2"></i> Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </nav>
  );
};

export default UserHeader;